export const isLoadingSelector = state => state.pageHelp.releaseNotes.loading;
export const releaseNotesSelector = state => state.pageHelp.releaseNotes.releaseNotes;
